import { Routes, Route, Navigate } from "react-router-dom";

import { useUser } from "services/auth";

import Dashboard from "./Dashboard";
import NewSurvey from "./NewSurvey";
import AnswerSurvey, { AnswerResponse } from "./AnswerSurvey";
import Survey from "./Survey";
import Login from "./Login";

const PrivateRoute: React.FC = ({ children = null }) => {
  const { session } = useUser();
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  return (<>{children}</>) ;
};

const PublicRoute: React.FC = ({children}) => {
  const { session } = useUser();
  if (session) {
    return <Navigate to="/" replace />;
  }
  return (<>{children}</>)
};

const Pages = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/surveys" />} />
      <Route path="/surveys" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/surveys/:surveyId" element={<PrivateRoute><Survey /></PrivateRoute>} />
      <Route path="/new" element={<PrivateRoute><NewSurvey /></PrivateRoute>} />
      <Route path="/answer" element={<PrivateRoute><AnswerSurvey /></PrivateRoute>} />
      <Route path="/answer/:responseStatus" element={<AnswerResponse />} />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
    </Routes>
  );
};

export default Pages;
